import React from 'react';
import ActionIconButton from './ActionIconButton';

const NewButton = ({title = 'Novo', ...props}) => (
    <ActionIconButton variant="new" title={title} {...props}/>
);

export default NewButton;
